import 'css-chunksrc/client/scenes/moveFolder/folderSelection/styles.scss';export default {
  "input": "_input_1ikxw_1",
  "placeholder": "_placeholder_1ikxw_15",
  "icon": "_icon_1ikxw_22",
  "listRoot": "_listRoot_1ikxw_28",
  "list": "_list_1ikxw_28",
  "opened": "_opened_1ikxw_44",
  "project": "_project_1ikxw_53",
  "projectIcon": "_projectIcon_1ikxw_64"
};